import { render, staticRenderFns } from "./CasePurchasingBayer.vue?vue&type=template&id=597fea9a&lang=pug"
import script from "./CasePurchasingBayer.vue?vue&type=script&lang=js"
export * from "./CasePurchasingBayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports